function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.88878 13.1413V11.0009C4.88878 10.4545 5.35844 10.0116 5.93779 10.0116H8.05561C8.33382 10.0116 8.60064 10.1158 8.79737 10.3014C8.9941 10.4869 9.10462 10.7385 9.10462 11.0009V13.1413C9.10286 13.3685 9.19731 13.5869 9.36701 13.7481C9.53671 13.9093 9.76761 14 10.0085 14H11.4533C12.1282 14.0016 12.7759 13.75 13.2537 13.3006C13.7315 12.8511 14 12.2409 14 11.6045V5.5068C14 4.99272 13.7584 4.50509 13.3402 4.17527L8.42507 0.473108C7.57007 -0.176007 6.34503 -0.155049 5.51555 0.522885L0.712535 4.17527C0.274651 4.49537 0.0129333 4.98445 0 5.5068V11.5983C0 12.9247 1.14018 14 2.54665 14H3.95853C4.4588 14 4.86537 13.6194 4.86899 13.1476L4.88878 13.1413Z",
  fill: "#E0E0E0"
});

var SvgHomewhite = function SvgHomewhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomewhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homewhite.f5a76648.svg";
export { ForwardRef as ReactComponent };